import styled, { keyframes } from 'styles/styled';

export const TabsRow = styled.div`
  display: flex;
  justify-content: center;
  margin: 8px auto 18px auto;
  width: 100%;
`;

export const TabsContainer = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 4px;
  border-radius: 999px;
  background: rgba(239, 239, 239, 0.12);
`;

export const TabButton = styled.button<{ $selected: boolean }>`
  border: 1px solid ${({ $selected }) => ($selected ? '#52D381' : 'transparent')};
  background: ${({ $selected }) => ($selected ? 'rgba(0,0,0,0.35)' : 'transparent')};
  color: ${({ $selected }) => ($selected ? '#52D381' : '#EFEFEF')};
  border-radius: 999px;
  padding: 8px 18px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s ease, border-color 0.15s ease;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    opacity: 0.92;
  }

  @media (max-width: 720px) {
    padding: 6px 14px;
    font-size: 14px;
  }
`;

export const RewardTitle = styled.h3`
  font-size: 22px;
  font-weight: 700;
  color: #EFEFEF;
  text-align: center;
  margin: 18px auto 10px auto;
  max-width: 560px;

  @media (max-width: 720px) {
    font-size: 18px;
    margin: 12px auto 8px auto;
  }
`;

export const RewardDisclaimer = styled.div`
  font-size: 12px;
  font-weight: 300;
  color: #EFEFEF;
  text-align: center;
  opacity: 0.6;
  margin: 0 auto 10px auto;

  @media (max-width: 720px) {
    font-size: 11px;
  }
`;

export const RewardAmount = styled.div`
  font-size: 58px;
  font-weight: 700;
  color: #52D381;
  text-align: center;
  margin: 0 auto;
  line-height: 1;

  @media (max-width: 720px) {
    font-size: 44px;
  }
`;

export const RewardUsd = styled.div`
  font-size: 26px;
  font-weight: 300;
  color: #EFEFEF;
  text-align: center;
  margin: 6px auto 0 auto;
  opacity: 0.9;

  @media (max-width: 720px) {
    font-size: 18px;
  }
`;

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const RewardSpinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid rgba(239, 239, 239, 0.2);
  border-top-color: #EFEFEF;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  margin: 18px auto 0 auto;
`;

export const RewardStatus = styled.div`
  font-size: 16px;
  color: #EFEFEF;
  text-align: center;
  margin: 18px auto 0 auto;
`;

export const RewardSubStatus = styled.div`
  font-size: 14px;
  font-weight: 300;
  color: #EFEFEF;
  text-align: center;
  margin: 8px auto 0 auto;
  opacity: 0.85;
  white-space: pre-line;
`;

export const BreakdownSection = styled.div`
  width: 100%;
  margin: 20px auto 0 auto;
`;

export const BreakdownRow = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 3px;
`;

export const BreakdownLabel = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: #EFEFEF;
  width: 50%;
  text-align: right;
  margin: 0 5px;

  @media (max-width: 720px) {
    font-size: 12px;
  }
`;

export const BreakdownValue = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: #52D381;
  width: 50%;
  text-align: left;
  margin: 0 5px;

  @media (max-width: 720px) {
    font-size: 12px;
  }
`;

export const InfoSection = styled.div`
  width: 100%;
  margin: 24px auto 0 auto;
`;

export const InfoLabel = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #EFEFEF;
  margin-bottom: 4px;
  text-align: center;

  @media (max-width: 720px) {
    font-size: 12px;
  }
`;

export const InfoValueRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InfoValue = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: #52D381;
  margin: 0 5px;

  @media (max-width: 720px) {
    font-size: 12px;
  }
`;

export const CopyWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const CopyButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  line-height: 0;

  img {
    width: 18px;
    height: 18px;
  }

  &:hover {
    opacity: 0.9;
  }
`;

export const CopiedText = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: #52D381;
`;

export const ContactText = styled.p`
  font-size: 14px;
  font-weight: 300;
  color: #EFEFEF;
  text-align: center;
  margin: 30px auto 0 auto;
  max-width: 400px;
  opacity: 0.85;
  line-height: 1.6;

  strong {
    font-weight: 700;
  }

  @media (max-width: 720px) {
    font-size: 12px;
  }
`;

export const Title = styled.h4`
  font-weight: 700;
  font-size: 24px;
  text-align: center;
  color: #EFEFEF;
  text-align: center;
  margin: 0 auto 15px auto;
    span {
    &.up_state {
      color: #52D381;
    }
    &.down_state {
      color: #FF6782;
    }
  }
  @media (max-width: 720px) {
    font-size: 16px;
    width: 280px;
    max-width: 90%;
    margin: 10px auto 15px auto;
  }
`;

export const SubTitle = styled.h4`
  font-size: 16px;
  color: #EFEFEF;
  font-weight: 700;
  text-align: center;
  margin-bottom: 8px;
  @media (max-width: 720px) {
    font-size: 12px;
    font-weight: 400;
    margin-bottom: 2px;
  }
  &.SecondSubTitle {
    font-weight: 300;
    margin-top: 30px;
    @media (max-width: 720px) {
      margin: 10px 0 20px 0;
      font-size: 14px;
      font-weight: bold;
    }
  }
`;

export const Text = styled.h5`
  font-size: 16px;
  color: #EFEFEF;
  font-weight: 700;
  text-align: center;
  margin: 0 5px;
  width: 50%;
  text-align: right;
  &:nth-child(2) {
    color: #52D381;
    text-align: left;
  }
  @media (max-width: 720px) {
    font-size: 12px;
  }
  span {
    &.up_state {
      color: #52D381;
    }
    &.down_state {
      color: #FF6782;
    }
  }
`;

export const Position = styled.h2<{ $isFirst?: boolean }>`
  font-size: 34px;
  font-weight: 500;
  color: ${({ $isFirst }) => ($isFirst ? '#52D381' : '#FF6782')};
  padding: 5px 0;
  @media (max-width: 720px) {
    font-size: 20px;
    padding: 2px 0;
  }
`;

export const SubText = styled.h6`
  font-size: 14px;
  color: #EFEFEF;
  font-weight: 300;
  @media (max-width: 720px) {
    font-size: 10px;
  }
`;

export const RowInformation = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 3px;
`;

export const ContentInformation = styled.div`
  margin-bottom: 20px;
  width: 100%;
  @media (max-width: 720px) {
    margin-bottom: 10px;
  }
`;

export const ContentInformationCenter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 10px;
  width: 100%;
  h5 {
    text-align: center;
  }
`;

export const Wrap = styled.div`
  width: 100%;
  margin: 0 auto;
  z-index: 10;
  position: relative;
  max-width: calc(100% - 150px);
  min-width: 240px;
  button {
    font-size: 15px;
    width: 100%;
    min-width: inherit;
    min-height: 40px;
    max-width: 460px;
    @media (max-width: 1020px) {
      max-width: 350px;
      margin: 0 auto;
    }
    @media (max-width: 720px) {
      font-size: 15px;
      width: 100%;
      min-width: inherit;
      min-height: 40px;
      max-width: 460px;
    }
  }
`;

export const WinWrap = styled.div`
  margin-bottom: 20px;
`;
